export const ttcabinetsRUBConstants = {
    SET_CABINETS_REQUEST_RUB: 'SET_CABINETS_REQUEST_RUB',
    SET_CABINETS_SUCCESS_RUB: 'SET_CABINETS_SUCCESS_RUB',
    SET_CABINETS_FAILURE_RUB: 'SET_CABINETS_FAILURE_RUB',

    SET_SELECT_OPTIONS_REQUEST_RUB: 'SET_SELECT_OPTIONS_REQUEST_RUB',
    SET_SELECT_OPTIONS_SUCCESS_RUB: 'SET_SELECT_OPTIONS_SUCCESS_RUB',
    SET_SELECT_OPTIONS_FAILURE_RUB: 'SET_SELECT_OPTIONS_FAILURE_RUB',

    SET_REQUEST_IN_PROGRESS_RUB: 'SET_REQUEST_IN_PROGRESS_RUB',
};
